import { useState } from "react";
import Hero from "./components/Hero";
import Footer from "./components/Footer";
import StickyNav from "./components/StickyNav";
import BookingModal from "./components/BookingModal";
import WechatModal from "./components/WechatModal";
import WechatRedirectModal from "./components/WechatRedirectModal";

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [wechatOpen, setWechatOpen] = useState(false);
  const [wechatRedirectOpen, setWechatRedirectOpen] = useState(false);

  const openBooking = () => setBookingOpen(true);
  const closeBooking = () => setBookingOpen(false);
  const openWechat = () => setWechatOpen(true);
  const closeWechat = () => setWechatOpen(false);
  const openWechatRedirect = () => setWechatRedirectOpen(true);
  const closeWechatRedirect = () => setWechatRedirectOpen(false);

  return (
    <div className="bg-cream-50">
      <StickyNav />
      <main>
        <Hero onBook={openBooking} onWechat={openWechat} />
      </main>
      <Footer />

      <BookingModal open={bookingOpen} onClose={closeBooking} />
      <WechatModal open={wechatOpen} onClose={closeWechat} />
      <WechatRedirectModal open={wechatRedirectOpen} onClose={closeWechatRedirect} />

      {/* mobile bottom action bar */}
      <div className="fixed bottom-0 inset-x-0 z-30 md:hidden bg-espresso-900/95 backdrop-blur border-t border-gold-400/30 px-4 py-3">
        <button
          onClick={openWechatRedirect}
          className="cursor-pointer whitespace-nowrap w-full inline-flex items-center justify-center gap-2 rounded-md bg-gold-400 hover:bg-gold-500 transition-colors text-espresso-900 font-sc font-medium text-sm py-2.5"
        >
          <img
            src="https://storage.readdy-site.link/project_files/d891e450-b88b-4862-a138-b46b8b4d4b90/7ac0acac-5e12-42bc-ac55-104655cf23ea_compressed_qw5.webp"
            alt="企业微信"
            className="w-5 h-5 object-contain"
          />
          添加企业微信
        </button>
      </div>
    </div>
  );
}